import { Injectable }              from '@angular/core';
import { HttpErrorResponse }       from '@angular/common/http';
import { Router }                  from '@angular/router';

import { AuthErrorStateService }   from './auth-error-state.service';
import { TokenService }            from '../tokens/token.service';

@Injectable()
export class HttpErrorHandlerService {

  // --- Service Constructor ---

  constructor(private authErrorStateService: AuthErrorStateService,
              private router: Router,
              private tokenService: TokenService) {}

  // --- Error Handling ---

  // Admin does not have permissions
  public handle403(error: HttpErrorResponse): void {
    this.tokenService.clearTokens();
    this.authErrorStateService.setErrorState(error);
  }

  // Admin is not logged in
  public handle401(isUpdate: boolean): void {
    // Set current state for redirection after login
    let currentParams = this.router.url;
    sessionStorage.setItem('lastState', currentParams);

    // Clear token and redirect to pink admin login
    this.tokenService.clearTokens();
    this.tokenService.login(isUpdate);
  }


}